import React from 'react'

import VIEW_OPTIONS_ICON from '@public/assets/action/icon_saturation.svg'
import TUTORIAL_VIDEO from '@public/assets/welcome-wizard/time-entry-tutorial-video.mp4'
import { useWelcomeWizardVideo } from '../../hooks/useWelcomeWizardVideo'

function TimeEntryTipsStep() {
  const videoRef = useWelcomeWizardVideo(TUTORIAL_VIDEO)

  return (
    <div className="max-w-[900px]">
      <p className="mt-3 text-base leading-[1.35] text-[#666]">
        The Time Entry Panel contains all accepted and confirmed time entries.
        This is where users review, organize, and prepare entries for
        submission. You can customize your workspace, manage entries, or change
        matter assignments.
      </p>
      <section className="mt-5">
        <h3 className="text-lg font-semibold">Manage Entries</h3>
        <ul className="mt-3 list-disc pl-6 text-base leading-[1.35] text-[#666]">
          <li>
            <div className="inline-flex flex-wrap items-center gap-x-2 gap-y-1">
              <span>Click the</span>
              <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#d9d9d9] bg-white">
                <img
                  alt="View options"
                  className="h-3.5 w-3.5"
                  src={VIEW_OPTIONS_ICON}
                />
              </span>
              <span>in the top-right corner to show or hide columns</span>
            </div>
          </li>
          <li>Drag and drop columns to reorder columns</li>
          <li>Resize column widths</li>
        </ul>
      </section>

      <p className="mt-2 text-base leading-[1.35] text-[#666]">
        Your preferred layout will be saved automatically.
      </p>

      <video
        ref={videoRef}
        className="mt-5 aspect-[900/518] w-full rounded-[20px] bg-black object-contain shadow-[0_1px_2px_rgba(0,0,0,0.3),0_2px_6px_2px_rgba(0,0,0,0.15)]"
        controls
        autoPlay
        key={TUTORIAL_VIDEO}
        preload="metadata"
      >
        <source src={TUTORIAL_VIDEO} type="video/mp4" />
      </video>
    </div>
  )
}

export default TimeEntryTipsStep
